import Store from './store';
import config from '../../../package.json';
const getKey = (key) => {
    if (!key) {
        return '';
    }
    let env = '';
    // let host = location.host
    // if (host.indexOf('sit') > -1) {
    //   env = 'sit_'
    // } else if (host.indexOf('dev') > -1) {
    //   env = 'dev_'
    // }
    return `${env}${key}`;
    // const env = process.env.NODE_ENV
    // return (env == 'production' ? '' : process.env.NODE_ENV + '_') + key
};
const utils = {
    ua: navigator.userAgent,
    weixin() {
        return this.ua.indexOf('MicroMessenger') > -1;
    },
    isPC() {
        const Agents = [
            'Android',
            'iPhone',
            'SymbianOS',
            'Windows Phone',
            'iPad',
            'iPod'
        ];
        let flag = true;
        for (let v = 0; v < Agents.length; v++) {
            if (navigator.userAgent.indexOf(Agents[v]) > -1) {
                flag = false;
                break;
            }
        }
        return flag;
    },
    ios() {
        return !!this.ua && /iPhone|iPad|iPod/gi.test(this.ua);
    },
    android() {
        return this.ua.indexOf('Android') > -1 || this.ua.indexOf('Linux') > -1;
    },
    isApp() {
        const isApp = !utils.weixin() &&
            (window.JavaScriptInterface ||
                (window.webkit && window.webkit.messageHandlers.jumpModule));
        return !!isApp;
    },
    isPassive() {
        let supportsPassiveOption = false;
        try {
            // @ts-ignore
            addEventListener('test', null, Object.defineProperty({}, 'passive', {
                get: function () {
                    supportsPassiveOption = true;
                }
            }));
        }
        catch (e) { }
        return supportsPassiveOption; // {passive: true} 就不会调用 preventDefault 来阻止默认滑动行为
    },
    /**
     * @param {Object} obj
     * @returns {string} result
     */
    queryStringify(obj) {
        function toQueryPair(key, value) {
            if (value === '') {
                return key;
            }
            return key + '=' + encodeURIComponent(value === '' ? '' : String(value));
        }
        let result = [];
        Object.keys(obj).forEach(key => {
            key = encodeURIComponent(key);
            const values = obj[key];
            if (values && values.constructor === Array) {
                const queryValues = [];
                for (let i = 0, len = values.length; i < len; i++) {
                    queryValues.push(toQueryPair(key, values[i]));
                }
                result = result.concat(queryValues);
            }
            else {
                result.push(toQueryPair(key, values));
            }
        });
        return result.join('&');
    },
    /**
     * @param {String || null } val
     * @return {Object |  String} result
     */
    getQueryParams(val) {
        const searchParams = new URLSearchParams(location.search);
        const result = Object.create(null);
        searchParams.forEach((value, key) => {
            result[key] = value;
        });
        if (val) {
            return result[val];
        }
        else {
            return result;
        }
    },
    setCookie(name, value, options) {
        name = getKey(name);
        let Days = (options && options.day) || 365;
        let domain = (options && options.domain) || location.hostname;
        let exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie =
            name +
                '=' +
                window.encodeURIComponent(value) +
                ';expires=' +
                exp.toUTCString() +
                '; path=/; domain=' +
                domain;
    },
    getCookie(name) {
        name = getKey(name);
        let arr;
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        // eslint-disable-next-line no-cond-assign
        if ((arr = document.cookie.match(reg))) {
            return window.decodeURIComponent(arr[2]);
        }
        else {
            return null;
        }
    },
    delCookie(name, domain) {
        name = getKey(name);
        let exp = new Date();
        exp.setTime(exp.getTime() - 1);
        let cval = this.getCookie(name);
        if (cval != null) {
            document.cookie =
                name +
                    '=' +
                    cval +
                    ';expires=' +
                    exp.toUTCString() +
                    '; path=/; domain=' +
                    domain;
        }
    },
    trim(text) {
        if (text) {
            return text.replace(/\s+/g, '');
        }
        else {
            return '';
        }
    },
    getUserId() {
        const USER_ID = Number(Store.get('USER_ID', 'local')) || 0;
        if (utils.isApp()) {
            if (utils.android()) {
                const aUserId = window.JavaScriptInterface.getUserId();
                return aUserId ? Number(aUserId) : 0;
            }
            else if (utils.ios()) {
                const iUserId = navigator.userAgent
                    .match(/\$\$userId=\d+\$\$/g)
                    ?.join('')
                    .replace(/[a-zA-Z$=]/g, '');
                return iUserId ? Number(iUserId) : 0;
            }
            else {
                return USER_ID;
            }
        }
        else {
            const COOKIE_USER_ID = utils.getCookie('USER_ID');
            if (COOKIE_USER_ID) {
                return Number(COOKIE_USER_ID) || 0;
            }
            else {
                return Number(USER_ID) || 0;
            }
        }
    },
    setUserId(val) {
        if (val) {
            Store.set('USER_ID', val, 'local');
        }
    },
    getUniqueId(randomLength = 10) {
        let idStr = Date.now().toString(36);
        idStr += Math.random().toString(36).substr(3, randomLength);
        return idStr;
    },
    userLogin(url = '', wechatAuth = false) {
        const userId = utils.getUserId();
        const openId = Store.get('openId', 'local');
        const backUrl = window.encodeURIComponent(url || location.pathname + location.search);
        const userLoginAuthFn = tye => {
            location.href = `/user/${tye}?backUrl=${backUrl}`;
        };
        if (utils.weixin()) {
            if (wechatAuth) {
                if (!userId || !openId) {
                    userLoginAuthFn('auth');
                }
            }
            else {
                userLoginAuthFn('login');
            }
        }
        else {
            if (!userId) {
                userLoginAuthFn('login');
            }
        }
    },
    getCookieItem(sKey) {
        return (decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' +
            encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') +
            '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null);
    },
    setCookieItem(sKey, sValue, vEnd, sPath = '/', sDomain, bSecure) {
        if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        let sExpires = '';
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires =
                        vEnd === Infinity
                            ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
                            : '; max-age=' + vEnd;
                    break;
                case String:
                    sExpires = '; expires=' + vEnd;
                    break;
                case Date:
                    sExpires = '; expires=' + vEnd.toUTCString();
                    break;
            }
        }
        document.cookie =
            encodeURIComponent(sKey) +
                '=' +
                encodeURIComponent(sValue) +
                sExpires +
                (sDomain ? '; domain=' + sDomain : '') +
                (sPath ? '; path=' + sPath : '') +
                (bSecure ? '; secure' : '');
        return true;
    },
    removeCookieItem(sKey, sPath = '/', sDomain) {
        if (!sKey || !this.hasCookieItem(sKey)) {
            return false;
        }
        document.cookie =
            encodeURIComponent(sKey) +
                '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
                (sDomain ? '; domain=' + sDomain : '') +
                (sPath ? '; path=' + sPath : '');
        return true;
    },
    hasCookieItem(sKey) {
        return new RegExp('(?:^|;\\s*)' +
            encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') +
            '\\s*\\=').test(document.cookie);
    },
    keysCookie() {
        let aKeys = document.cookie
            .replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '')
            .split(/\s*(?:=[^;]*)?;\s*/);
        for (let nIdx = 0; nIdx < aKeys.length; nIdx++) {
            aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
        }
        return aKeys;
    },
    getAuthorization() {
        if (!utils.isApp()) {
            return false;
        }
        if (utils.android()) {
            if (window.JavaScriptInterface &&
                window.JavaScriptInterface.getAuthorizationToken) {
                let appToken = window.JavaScriptInterface.getAuthorizationToken();
                if (appToken) {
                    return JSON.parse(appToken);
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        }
        else if (utils.ios()) {
            const anget = navigator.userAgent.match(/####(.*?)####/g);
            if (anget) {
                const angetStr = anget.join('').replace(/\\#\\#\\#\\#/g, '');
                // console.log('get token from ios app', angetStr)
                if (angetStr && angetStr.indexOf('=') > -1) {
                    const angetArr = angetStr.split('=');
                    if (angetArr.length < 2) {
                        return null;
                    }
                    else {
                        return JSON.parse(angetArr[1].replace(/\\/g, ''));
                    }
                }
                else {
                    // console.log('ios app is low version ')
                    return null;
                }
            }
            else {
                return null;
            }
        }
    },
    getToken() {
        const authorizationToken = utils.getAuthorization();
        if (authorizationToken && authorizationToken.token) {
            return authorizationToken.token;
        }
        else {
            return utils.getCookieItem('token');
        }
    },
    getTokenObj() {
        if (!utils.isApp()) {
            return {
                token: utils.getCookieItem('token'),
                version: config.version,
                userId: utils.getUserId()
            };
        }
        if (utils.android()) {
            if (window.JavaScriptInterface.getAuthorizationToken) {
                let jsonStr = window.JavaScriptInterface.getAuthorizationToken();
                return jsonStr && JSON.parse(jsonStr);
            }
            else {
                return {
                    token: '',
                    version: config.version,
                    userId: 0
                };
            }
        }
        else if (utils.ios()) {
            let agent = navigator.userAgent;
            if (agent.split('####')) {
                return JSON.parse(agent.split('####')[1].replace('tokenStr=', ''));
            }
            else {
                return {
                    token: '',
                    version: config.version,
                    userId: 0
                };
            }
        }
    },
    callPhone(telphone) {
        // 拨打电话
        if (utils.android()) {
            window.JavaScriptInterface.tellPhone(String(telphone));
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.CallCustomerService.postMessage(telphone);
        }
    },
    mobileApi(data) {
        if (utils.android()) {
            window.JavaScriptInterface.mobileApi(JSON.stringify(data));
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.mobileApi.postMessage(data);
        }
    },
    setExerciseId(data) {
        if (utils.android()) {
            window.JavaScriptInterface.setExerciseId(JSON.stringify(data));
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.setExerciseId.postMessage(data);
        }
    },
    backHome() {
        // 返回首页
        if (utils.android()) {
            window.JavaScriptInterface.goMainHome();
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.mineTeachetBackHome.postMessage('');
        }
        else {
            location.assign('/');
        }
    },
    prevPage(data) {
        // 返回上一页
        if (utils.isApp() && data) {
            this.postMessage(data);
        }
        else {
            history.go(-1);
        }
    },
    webViewBack() {
        this.mobileApi({ type: 'webViewBack' });
    },
    appShare(data, type = 'share') {
        // shareWechat 微信好友
        // shareFriend 朋友圈
        this.mobileApi({ type, data: data });
    },
    /**
     * @params
     * type
     *    omo_operation_detail omo导览页
     *    online_operation_detail  线上共学营导览页
     *    operation_detail 训练营详情
     *    pbl_detail pbl详情
     *    mall_detail  商城详情
     *    open_detail  公开课详情
     *    smart_exercise_detail 病历练习详情
     *    vip_member_open  开通会员
     *    article_detail  文章详情
     *    pbl_discuss_create pbl话题创建
     *    image_preview 图片放大
     *    mall_detail 商品详情
     *    meeting_detail 训练营
     * id meetingId 或 视频id 等
     * fullScreen 是否全屏
     * url webview 地址
     *
     */
    postMessage({ type, id = '', orderId, url, fullScreen, tab }) {
        const data = {
            typeId: type,
            dataId: id
        };
        if (orderId) {
            data.orderId = orderId;
        }
        if (url) {
            data.url = url;
        }
        if (fullScreen) {
            data.full_screen = fullScreen;
        }
        tab && (data.type = tab);
        if (utils.android()) {
            window.JavaScriptInterface.jumpModule(JSON.stringify(data));
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.jumpModule.postMessage(data);
        }
    },
    imagePreview({ type, images, posIndex }) {
        let imgs = JSON.parse(JSON.stringify(images));
        const data = {
            typeId: type,
            images: imgs,
            posIndex
        };
        if (utils.android()) {
            window.JavaScriptInterface.jumpModule(JSON.stringify(data));
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.jumpModule.postMessage(data);
        }
    },
    hiddenAppNavBar() {
        // 隐藏app webview navbar
        if (utils.isApp()) {
            if (utils.android()) {
                window.JavaScriptInterface &&
                    window.JavaScriptInterface.hiddenNavidationBar();
            }
            else if (utils.ios()) {
                window.webkit.messageHandlers.hiddenNavidationBar.postMessage('');
            }
        }
    },
    appFullScreen() {
        // 隐藏app webview 全屏
        if (utils.android()) {
            window.JavaScriptInterface.fullScreen();
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.fullScreen.postMessage('');
        }
    },
    /**
     * @param {string} video 视频地址
     */
    playVideoFullScreen(video) {
        if (utils.android()) {
            window.JavaScriptInterface.bojuVideo(JSON.stringify({ video }));
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.bojuVideo.postMessage({ video });
        }
    }
};
export default utils;
